import React from 'react';
import MultiButtonClick from '../MultiButtonClick';

const Level15 = ({progress, failure}) => {
  return (
    <MultiButtonClick numButtons={7} correctButtonIndex={6} prompt={"click the right button"} progress={progress} failure={failure}/>
  );
};

export default Level15;